import React, { useState, useEffect } from 'react';
import { Page, Navbar, NavRight, Segmented, Button, Block, Tabs, Tab, Icon, Link } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const TabOrders = () => {
  const [data, setData] = useState([]);  
  useEffect(() => {
    axios.get(API_BASE_URL + 'eventbyrest/id/'+ localStorage.getItem('id'), {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: { }
      })
      .then(response => { setData(response.data);} )
      .catch(error => console.log(error));
  }, []);
  return (
    <Page className='bg-white'>
      <Navbar title="Orders" noShadow>
        <NavRight>
            <Link href="/menusearch/" transition="f7-parallax">
              <Icon ios="material:search" aurora="material:search" md="material:search"></Icon>
            </Link>            
        </NavRight>   
      </Navbar>
      <Block className="mt-0 p-2 pt-0 mb-0">
        <Segmented strong tag="p">
          <Button tabLink="#order-1" tabLinkActive>Orders</Button>
          <Button tabLink="#order-2">Cancelled Orders</Button>          
        </Segmented>
      </Block>
      <Tabs>
        <Tab id="order-1" tabActive>
        <Block className="pr-3 mt-0">
        {data.length ? (
            data.map(order => (
              <table className="table table-light table-sm table-borderless">
                <thead>
                  <tr className="table-secondary">
                    <th width="30"><img
                        alt=""
                        slot="media"
                        src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg"
                        width="40"
                        className="rounded-circle"
                    /></th>
                    <th>{order.customer[0].cust_fname}<br/><small>Today at 12:30 pm</small></th>
                    <th colSpan={2} className="text-end">Order ID: {order.token}<br/><small>Total: $ {order.total}</small></th>
                  </tr>
                </thead>
                <tbody>
                {order.item.map(items => (
                  <tr><td colSpan={2}>{items.menu_item_name}</td><td className="text-center">Tray: 1</td><td className="text-end">$ {items.menu_item_price}</td></tr>
                ))}
                </tbody>
                <tfoot className="border-top">
                  <tr>
                    <th colSpan={2}>Message: <br/><span className="text-success text-2">Order Status</span></th>
                    <th rowSpan={2} colSpan={2} className="text-end"><Button fill small className="text-1" href="/orderdetails/">View Order</Button></th>
                  </tr>
                </tfoot>
              </table>
              ))
          ) : (
            <Block loginScreen className='text-center'>
              <h4>No Order</h4>
              <Icon material="restaurant_menu" ios="f7:restaurant_menu" size="64px" color='purple'/>
              <p className='text-2'>Here can find your Order Details</p>
            </Block>
          )} 
        </Block>    
        </Tab>
        <Tab id="order-2">
        <Block className="pr-3 mt-0">
        {data.length ? (
            data.map(order => (
              <table className="table table-light table-sm table-borderless">
                <thead>
                  <tr className="table-secondary">
                    <th width="30"><img
                        alt=""
                        slot="media"
                        src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg"
                        width="40"
                        className="rounded-circle"
                    /></th>
                    <th>{order.customer[0].cust_fname}<br/><small>Today at 12:30 pm</small></th>
                    <th colSpan={2} className="text-end">Order ID: {order.token}<br/><small>Total: $ {order.total}</small></th>
                  </tr>
                </thead>
                <tbody>
                {order.item.map(items => (
                  <tr><td colSpan={2}>{items.menu_item_name}</td><td className="text-center">Tray: 1</td><td className="text-end">$ {items.menu_item_price}</td></tr>
                ))}
                </tbody>
                <tfoot className="border-top">
                  <tr>
                    <th colSpan={2}>Message: <br/><span className="text-success text-2">Order Status</span></th>
                    <th rowSpan={2} colSpan={2} className="text-end"><Button fill small className="text-1" href="/orderdetails/">View Order</Button></th>
                  </tr>
                </tfoot>
              </table>
              ))
          ) : (
            <Block loginScreen className='text-center'>
              <h4>No Order</h4>
              <Icon material="restaurant_menu" ios="f7:restaurant_menu" size="64px" color='purple'/>
              <p className='text-2'>Here can find your Order Details</p>
            </Block>
          )} 
        </Block>
        </Tab>
      </Tabs>      
    </Page>
  );
};

export default TabOrders;